import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

const BADGE_SIZE_PX = 24;

export const StyledSignalTypeChip = styled(Flex)`
    box-sizing: border-box;
    gap: 8px;
    padding: 4px 14px 4px 4px;
    border-radius: 50px;
    background: ${colorsPalettes.bluegrey[300]};
    /* A read-only marker of what the enrichment covers — nothing here responds to a click. */
    cursor: default;
`;

export const StyledSignalTypeIconBadge = styled(Flex)`
    flex-shrink: 0;
    width: ${BADGE_SIZE_PX}px;
    height: ${BADGE_SIZE_PX}px;
    border-radius: 50%;
    background: ${colorsPalettes.carbon[0]};
`;

export const StyledSignalTypeLabel = styled.span`
    ${setFontVariant("body2", colorsPalettes.carbon[500])}
    white-space: nowrap;
`;
